import { APP_INITIALIZER, Injector } from '@angular/core';
import { combineLatest } from 'rxjs';
import { RoutesService } from '@abp/ng.core';
import { TEST_RESULTS_MANAGEMENT_ROUTE_VISIBILITY } from './features.token';
import { ProviderConsts } from 'src/app/shared/Constants/providers.constants';

export const TEST_RESULTS_MANAGEMENT_VISIBLE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: testResultsManagementVisibility,
        deps: [Injector],
        multi: true,
    },
];

export function testResultsManagementVisibility(injector: Injector) {
    return () => {
        const isTestResultsManagementFeatureEnable$ = injector.get(TEST_RESULTS_MANAGEMENT_ROUTE_VISIBILITY);
        const routes = injector.get(RoutesService);
        combineLatest([isTestResultsManagementFeatureEnable$]).subscribe(
        ([isTestResultsManagementFeatureEnable]) => {
            routes.patch(ProviderConsts.TEST_RESULT_ROUTE_PATCH_NAME, {
                invisible: !isTestResultsManagementFeatureEnable,
            });
        },
        );
    };
}
